export default {
  QUOTE: "क्वोट",
  QUOTES: "क्वोट्स",
};
